import React, { FunctionComponent } from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Action } from '../../styles';
import TransferWithinAStationIcon from '@material-ui/icons/TransferWithinAStation';

type isConfirmType = {
    id: number | undefined;
    name: string;
    open: boolean;
};

type ReloginButtonProps = {
    id: number;
    login: string;
    setIsReLogin: (item: isConfirmType) => void;
};

function cmp(prev: ReloginButtonProps, next: ReloginButtonProps): boolean {
    return prev.id === next.id && prev.login === next.login;
}

const ReloginButton: FunctionComponent<ReloginButtonProps> = React.memo(({ id, setIsReLogin, login }) => {
    const [t] = useTranslation();
    return <Tooltip title={String(t('ru.common.confirm.relogin'))} placement="top">
        <Action bg={'#919191'} onClick={() => setIsReLogin({ id: id, name: login, open: true })} >
            <IconButton>
                <TransferWithinAStationIcon style={{ width: '15px', color: '#fff' }} />
            </IconButton>
        </Action>
    </Tooltip>;
}, cmp);

export default ReloginButton;